import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="lightest" className="titleBlock-align-left industry-usecase-title" mdxType="TitleBlock" />
    <h2 {...{
      "id": "for-use-across-industries"
    }}>{`For use across industries`}</h2>
    <ResourceCard slots="image, heading, text" width="25%" theme='lightest' className="useCaseCard-doc-gen" mdxType="ResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "478px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.81249999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/ca8c83b288075429267b1f959139321f/5530d/government.webp 320w", "/document-services/static/ca8c83b288075429267b1f959139321f/3c317/government.webp 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/ca8c83b288075429267b1f959139321f/8980b/government.jpg 320w", "/document-services/static/ca8c83b288075429267b1f959139321f/74f5b/government.jpg 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/ca8c83b288075429267b1f959139321f/74f5b/government.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "government"
    }}>{`Government`}</h2>
    <p>{`Ensure important public information is accessible to all citizens.`}</p>
    <ResourceCard slots="image, heading, text" width="25%" theme='lightest' className="useCaseCard-doc-gen " mdxType="ResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "478px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.81249999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/3010637e2a836f3fd3b60f143a18887e/5530d/educationl.webp 320w", "/document-services/static/3010637e2a836f3fd3b60f143a18887e/3c317/educationl.webp 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/3010637e2a836f3fd3b60f143a18887e/8980b/educationl.jpg 320w", "/document-services/static/3010637e2a836f3fd3b60f143a18887e/74f5b/educationl.jpg 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/3010637e2a836f3fd3b60f143a18887e/74f5b/educationl.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "education"
    }}>{`Education`}</h3>
    <p>{`Make educational content more accessible for students, teachers, and staff.`}</p>
    <ResourceCard slots="image, heading, text" width="25%" theme='lightest' className="useCaseCard-doc-gen " mdxType="ResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "478px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.81249999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/fc51311d38912282f7e4ecf52e46711c/5530d/financial.webp 320w", "/document-services/static/fc51311d38912282f7e4ecf52e46711c/3c317/financial.webp 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/fc51311d38912282f7e4ecf52e46711c/8980b/financial.jpg 320w", "/document-services/static/fc51311d38912282f7e4ecf52e46711c/74f5b/financial.jpg 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/fc51311d38912282f7e4ecf52e46711c/74f5b/financial.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "financial-services"
    }}>{`Financial services`}</h3>
    <p>{`Improve the accessibility of important financial documents such as statements, insurance cliams, and more for customers.`}</p>
    <ResourceCard slots="image, heading, text" width="25%" theme='lightest' className="useCaseCard-doc-gen " mdxType="ResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "478px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "62.81249999999999%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/baf5357a64e6f9553933d072300ea443/5530d/retail.webp 320w", "/document-services/static/baf5357a64e6f9553933d072300ea443/3c317/retail.webp 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/baf5357a64e6f9553933d072300ea443/8980b/retail.jpg 320w", "/document-services/static/baf5357a64e6f9553933d072300ea443/74f5b/retail.jpg 478w"],
            "sizes": "(max-width: 478px) 100vw, 478px",
            "type": "image/jpeg"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/baf5357a64e6f9553933d072300ea443/74f5b/retail.jpg",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "retail-and-e-commerce"
    }}>{`Retail and E-commerce`}</h3>
    <p>{`Enhance user experience by improving the accessibility of PDFs related to important products and services for customers.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      